import React, { Component } from "react";
import Spinner from "components/Spinner";
import MaterialTable from "material-table";
import {
  EYE_ICON,
  TRASH_ICON,
  EDIT_ICON,
  CALENDER_ICON,
  CALENDAR_CHECK_ICON
} from "assets/constants/Icons";
import { INTERVAL, TYPE_SUCCESS, TYPE_FAIL } from "assets/constants/Constants";
import ShowToast from "components/ShowToast";
import moment from "moment";
import { getEnquiryList, deleteEnquiry } from "lib/axiosUtils";
import { ThemeProvider } from "@mui/styles";
import { createTheme } from "@mui/material";
import { hasPermission } from "components/Permission";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";

export class EnquiryListPage extends Component {
  state = {
    isLoading: true,
    enquiries: [],
    mytheme: createTheme({}),
    viewOpen: false,
    viewRow: null
  };

  componentDidMount() {
    this.fetchEnquiries();
  }

  fetchEnquiries = async () => {
    this.setState({ isLoading: true });
    try {
      const resp = await getEnquiryList();
      console.log("Enquiry API response:", resp?.data?.result);
      const raw = resp?.data?.result ?? [];
      const mapped = raw.map((e, idx) => ({
        id: e._id || `row_${idx}`,
        enquiryNumber: e.enquiryNumber || "",
        customerName: e.customer?.customer_name || "-",
        regionName: e.region?.name || "-",
        status: e.status || "",
        machine: e.machineModel || "-",
        quotationNumber: e.quotation_number || "-",
        createdDate: e.created_date_time || null,
        designEngineerName: e.designEngineerId ? `${e.designEngineerId.first_name} ${e.designEngineerId.last_name}` : "-",
        raw: e
      }));
      this.setState({ enquiries: mapped, isLoading: false });
    } catch (err) {
      console.error("[EnquiryListPage] fetch enquiries failed", err);
      this.setState({ isLoading: false });
      ShowToast(
        "Failed to load enquiries",
        TYPE_FAIL,
        INTERVAL,
        this.props,
        ""
      );
    }
  };

  viewEnquiry = (row) => this.setState({ viewOpen: true, viewRow: row });
  closeView = () => this.setState({ viewOpen: false, viewRow: null });

  handleDelete = async (row) => {
    if (!row?.id)
      return ShowToast(
        "Invalid enquiry id",
        TYPE_FAIL,
        INTERVAL,
        this.props,
        ""
      );
    if (!window.confirm("Are you sure you want to delete this enquiry?"))
      return;
    this.setState({ isLoading: true });
    try {
      const del = await deleteEnquiry(row.id);
      if (del?.status !== 204) {
        this.setState({ isLoading: false });
        return ShowToast("Delete failed", TYPE_FAIL, INTERVAL, this.props, "");
      }
      ShowToast(
        "Enquiry deleted successfully",
        TYPE_SUCCESS,
        INTERVAL,
        this.props,
        ""
      );
      this.fetchEnquiries();
    } catch (err) {
      console.error("[EnquiryListPage] delete failed", err);
      this.setState({ isLoading: false });
      ShowToast(
        "Delete failed. Please try again.",
        TYPE_FAIL,
        INTERVAL,
        this.props,
        ""
      );
    }
  };
  editEnquiry = (row) => {
    const id = row?.id;
    if (!id) return console.warn("No enquiry id:", row);
    this.props.history.push(`/create-enquiry/${id}`);
  };
  createEnquiry = () => {
    this.props.history.push("/create-enquiry");
  };
  renderViewModal() {
    const { viewOpen, viewRow } = this.state;
    if (!viewOpen || !viewRow) return null;
    const r = viewRow;
    return (
      <div className="custom_modal">
        <div className="modal_body">
          <button
            type="button"
            style={{ fontSize: 25 }}
            className="close text-right"
            onClick={this.closeView}
          >
            &times;
          </button>
          <h5 className="mb-3">
            <b>Enquiry Details</b>
          </h5>
          <hr />
          <div
            style={{
              background: "#f8f9fa",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #dee2e6",
              margin: "14px"
            }}
          >
            <p>
              <b>Enquiry Number:</b> {r.enquiryNumber || "-"}
            </p>
            <p>
              <b>Customer:</b> {r.customerName || "-"}
            </p>
            <p>
              <b>Region:</b> {r.regionName || "-"}
            </p>
            <p>
              <b>Status:</b> {r.status || "-"}
            </p>
            <p>
              <b>Design Engineer:</b> {r.designEngineerName || "-"}
            </p>
            <p>
              <b>Created Date:</b>{" "}
              {r.createdDate
                ? moment(r.createdDate).format("DD MMM YYYY")
                : "-"}
            </p>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.isLoading) return <Spinner />;

    return (
      <div className="main-content">
        <div
          className="pagetitle row"
          style={{ color: "black", paddingTop: 15, marginTop: "-25px" }}
        >
          <div
            className="col-md-10 sm_device"
            style={{ display: "flex", alignItems: "center" }}
          >
            <FormatListNumberedIcon />
            <span style={{ marginLeft: "7px", marginRight: "10px" }}>Enquiry</span>
            <AddCircleIcon
              onClick={this.createEnquiry}
              style={{
                cursor: "pointer",
                color: "#1976d2",
                marginLeft: "2px"
              }}
              titleAccess="Create Enquiry"
            />
          </div>

          <div className="col-md-2 sm_device" style={{ textAlign: "right" }}>
            <i className={CALENDER_ICON}></i> {moment().format("DD MMM YYYY")}
          </div>
        </div>
        <div
          style={{
            borderBottom: "1px solid lightgray",
            marginBottom: 15,
            marginTop: 10
          }}
        />

        <div className="list-wrapper">
          <div
            className="mt-4 border list-table-div project-list-table-div"
            style={{ marginBottom: 50 }}
          >
            {this.state.enquiries.length > 0 ? (
              <ThemeProvider theme={this.state.mytheme}>
                <MaterialTable
                  title=""
                  columns={[
                    {
                      title: "Enquiry Number",
                      field: "enquiryNumber",
                      sorting: true,
                      filtering: true,
                      cellStyle: {
                        fontSize: 12,
                        color: "#2d3d42",
                        fontWeight: "bold"
                      },
                    },
                    {
                      title: "Customer Name",
                      field: "customerName",
                      sorting: true,
                      filtering: true,
                      cellStyle: {
                        fontSize: 12,
                        color: "#2d3d42",
                        fontWeight: "bold"
                      },
                    },
                    {
                      title: "Region",
                      field: "regionName",
                      sorting: true,
                      filtering: true,
                      cellStyle: {
                        fontSize: 12,
                        color: "#2d3d42",
                        fontWeight: "bold"
                      },
                    },
                    {
                      title: "Status",
                      field: "status",
                      sorting: true,
                      filtering: true,
                      cellStyle: {
                        fontSize: 12,
                        color: "#2d3d42",
                        fontWeight: "bold"
                      },
                    },
                    // {
                    //   title: "Design Engineer",
                    //   field: "designEngineerName",
                    //   sorting: true,
                    //   filtering: true,
                    //   cellStyle: {
                    //     fontSize: 12,
                    //     color: "#2d3d42",
                    //     fontWeight: "bold"
                    //   },
                    // },
                    {
                      title: "Machine",
                      field: "machine",
                      sorting: true,
                      filtering: true,
                      cellStyle: {
                        fontSize: 12,
                        color: "#2d3d42",
                        fontWeight: "bold"
                      },
                    },
                    {
                      title: "Enquiry Recd",
                      field: "enquiryRecd",
                      sorting: true,
                      filtering: true,
                      render:(row) => row.createdDate ? moment(row.createdDate).format("DD MMM YYYY") : "-",
                      cellStyle: {
                        fontSize: 12,
                        color: "#2d3d42",
                        fontWeight: "bold"
                      },
                    },
                    {
                      title: "Quotation No",
                      field: "quotationNumber",
                      sorting: true,
                      filtering: true,
                      cellStyle: {
                        fontSize: 12,
                        color: "#2d3d42",
                        fontWeight: "bold"
                      },
                    }
                  ]}
                  data={this.state.enquiries}
                  actions={[
                    {
                      icon: () => <i className={EYE_ICON} />,
                      tooltip: "View Enquiry",
                      onClick: (_e, row) => this.viewEnquiry(row)
                    },
                    {
                      icon: () => <i className={EDIT_ICON} />,
                      tooltip: "Edit Enquiry",
                      onClick: (_e, row) => this.editEnquiry(row)
                    },
                    {
                      icon: () => <i className={TRASH_ICON} />,
                      tooltip: "Delete Enquiry",
                      onClick: (_e, row) => this.handleDelete(row)
                    },
                    {
                      icon: () => <i className={CALENDAR_CHECK_ICON} />,
                      tooltip: "Convert to PO",
                      onClick: (_e, row) => this.props.history.push(`/create-po/${row.id}`),
                      hidden: (row) => row.status !== 'Offer Submitted'
                    },
                  ]}
                  options={{
                    pageSize: 5,
                    actionsColumnIndex: -1,
                    filtering: true,
                    sorting: true,
                    exportButton: true,
                    headerStyle: {
                      color: "#2d3d42",
                      fontWeight: "bolder",
                      fontSize: 14
                    },
                    cellStyle: { color: "#2d3d42", fontSize: 12 },
                  }}
                />
              </ThemeProvider>
            ) : (
              <div className="text-center pt-2">No records found!</div>
            )}
            {this.renderViewModal()}
          </div>
        </div>
      </div>
    );
  }
}

export default EnquiryListPage;
